<template>
  <div>
    <div v-if="lang === 'zh-CN'" class="Section0" style="layout-grid: 15.6pt">
      <p class="MsoNormal" align="center" style="text-align: center">
        <b>
          <span>
            <font face="等线">水母物联隐私政策</font>
          </span>
        </b>
        <b>
          <span style="font-weight: bold">
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p class="MsoNormal" align="center" style="text-align: center">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">本版发布</font>
            <font face="等线">/更新日期：2024年10月08日</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">生效日期：</font>
            <font face="等线">2024年10月08日</font>
          </span>
        </b>
        <b>
          <span style="font-weight: bold">
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p class="MsoNormal">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">引言</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal" style="text-indent: 21pt; mso-char-indent-count: 2">
        <span style="">
          <font face="等线"
            >感谢您信任并使用水母物联！保护用户的个人信息及隐私是水母物联服务提供者（以下简称</font
          >
          <font face="等线">
            “我们”）的一项基本原则。为了向您和其他用户提供更好的服务，我们努力使用简明易懂的表述，希望通过本隐私政策（以下简称“本政策”）向您说明，我们如何收集、使用、存储、披露和处理这些信息，以及为保障您享有的相关权利我们为您提供的查询、更正、删除您个人信息的方式。同时，我们为您提供便利功能选项，在需要时按照本政策的指引，做出您认为适当的选择，管理您的个人信息。我们承诺不以欺诈、诱骗、误导的方式收集您的个人信息，仅收集必要的信息。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal" style="text-indent: 21pt; mso-char-indent-count: 2">
        <span style="">
          <font face="等线">
            本政策适用于水母物联服务，即我们本政策适用于所有水母物联产品及服务，包括通过水母物联官方网站、水母物联客户端软件、水母物联通过自有品牌智能硬件提供的服务，以及被集成入第三方产品或软件的功能
          </font>
          <font face="等线"
            >/服务（如小程序、公众号下的水母物联服务）（以下统称“我们的产品与/或服务”）。水母物联服务提供者为</font
          >
        </span>
        <b>
          <span style="font-weight: bold; margin-top: 30rpx">
            <font face="等线">深圳水母物联安全技术有限公司</font>
          </span>
        </b>
        <b>
          <span style="font-weight: bold">
            <font face="等线"></font>
          </span>
        </b>
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >注册地址为:
              深圳市龙岗区宝龙街道宝龙社区南同大道28号贝斯达医疗器械大厦1栋B号厂房1B301。</font
            >
          </span>
        </b>
        <b>
          <span style="font-weight: bold">
            <font face="等线"></font>
          </span>
        </b>
        <b>
          <span style="font-weight: bold">
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p class="MsoNormal" style="text-indent: 21pt; mso-char-indent-count: 2">
        <span style="">
          <font face="等线"
            >需特别说明的是，本政策不适用于由第三方公司或个人提供的服务（以下简称</font
          >
          <font face="等线"
            >“第三方服务”）。为方便您使用水母物联，我们的产品和/或服务内可能含有第三方服务或其链接；</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">
              鉴于第三方将独立地收集并处理您的个人信息，我们无法控制，因此，除非另有法律规定，我们对第三方服务不承担责任，您需自行阅读理解第三方服务的隐私政策，并独立判断是否使用其服务
            </font>
          </span>
        </b>
        <span style="">
          <font face="等线">。</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal" style="text-indent: 21pt; mso-char-indent-count: 2">
        <span style="">
          <font face="等线">由于本政策与您所使用的产品和</font>
          <font face="等线"
            >/或服务息息相关，在您使用我们的产品和/或服务前，希望您仔细阅读并了解本政策，特别是以</font
          >
        </span>
        <span style="font-weight: bold">
          <font face="等线">粗体</font>
        </span>
        <span style="">
          <font face="等线">/下划线/斜体标识的条款。</font>
          <br />
        </span>
        <br />
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >您点击同意选项或使用水母物联服务，即意味着同意我们按照本政策收集、使用、存储、披露和处理您的相关个人信息。</font
            >
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >如果您有任何疑问、意见或建议，可以通过本政策</font
            >
          </span>
        </b>
        <span>
          <a href="#_Toc50281380">
            <b>
              <u>
                <span
                  class="16"
                  style="
                    color: rgb(70, 120, 134);
                    font-weight: bold;
                    text-decoration: underline;
                    text-underline: single;
                  "
                >
                  <font face="等线">第八节</font>
                </span>
              </u>
            </b>
          </a>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">约定的方式与我们进行联系。</font>
          </span>
        </b>
        <b>
          <span style="font-weight: bold">
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p class="MsoNormal">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">本政策将帮助您了解以下内容：</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <a href="#_Toc50281373">
            <u>
              <span
                class="16"
                style="
                  color: rgb(70, 120, 134);
                  text-decoration: underline;
                  text-underline: single;
                "
              >
                <font face="等线">一、定义</font>
              </span>
            </u>
          </a>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <a href="#_Toc50281374">
            <u>
              <span
                class="16"
                style="
                  color: rgb(70, 120, 134);
                  text-decoration: underline;
                  text-underline: single;
                "
              >
                <font face="等线">二、我们如何收集、使用您的个人信息</font>
              </span>
            </u>
          </a>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <a href="#_Toc50281375">
            <u>
              <span
                class="16"
                style="
                  color: rgb(70, 120, 134);
                  text-decoration: underline;
                  text-underline: single;
                "
              >
                <font face="等线"
                  >三、我们如何共享、转让、公开披露您的个人信息</font
                >
              </span>
            </u>
          </a>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <a href="#_Toc50281376">
            <u>
              <span
                class="16"
                style="
                  color: rgb(70, 120, 134);
                  text-decoration: underline;
                  text-underline: single;
                "
              >
                <font face="等线">四、我们如何保护和存储您的个人信息</font>
              </span>
            </u>
          </a>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <a href="#_Toc50281377">
            <u>
              <span
                class="16"
                style="
                  color: rgb(70, 120, 134);
                  text-decoration: underline;
                  text-underline: single;
                "
              >
                <font face="等线">五、您的权利</font>
              </span>
            </u>
          </a>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <a href="#_Toc50281378">
            <u>
              <span
                class="16"
                style="
                  color: rgb(70, 120, 134);
                  text-decoration: underline;
                  text-underline: single;
                "
              >
                <font face="等线">六、我们如何处理未成年人的个人信息</font>
              </span>
            </u>
          </a>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <a href="#_Toc50281379">
            <u>
              <span
                class="16"
                style="
                  color: rgb(70, 120, 134);
                  text-decoration: underline;
                  text-underline: single;
                "
              >
                <font face="等线">七、我们如何使用</font>
                <font face="等线">Cookie和同类技术</font>
              </span>
            </u>
          </a>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <a href="#_Toc50281380">
            <u>
              <span
                class="16"
                style="
                  color: rgb(70, 120, 134);
                  text-decoration: underline;
                  text-underline: single;
                "
              >
                <font face="等线">八、联系我们</font>
              </span>
            </u>
          </a>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <a href="#_Toc50281381">
            <u>
              <span
                class="16"
                style="
                  color: rgb(70, 120, 134);
                  text-decoration: underline;
                  text-underline: single;
                "
              >
                <font face="等线">九、本政策联如何更新</font>
              </span>
            </u>
          </a>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">一、定义</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >1.个人信息：以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >2.个人敏感信息：一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息，包括</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >身份证件号码、个人生物识别信息、银行账户、财产信息、行踪轨迹、交易信息、</font
            >
            <font face="等线">14岁以下（含）儿童信息的个人信息</font>
          </span>

          <span style="">
            <font face="等线">（</font>
          </span>

          <span style="font-weight: bold">
            <font face="等线">为便于您在阅读时特别关注，</font>
          </span>

          <span style="">
            <font face="等线">我们将在本政策中对具体个人敏感信息以</font>
          </span>

          <span style="font-weight: bold">
            <font face="等线">粗体</font>
          </span>

          <span style="">
            <font face="等线">进行显著标识）。</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">
            3.匿名化：通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。个人信息经匿名化处理后所得的信息不属于个人信息。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >4.去标识化：通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别或关联个人信息主体的过程。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >5.SDK：软件开发工具包，是特定的软件包、软件框架、硬件平台、操作系统建立应用软件时的开发工具的集合。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">6.儿童：不满十四周岁的未成年人。</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">二、我们如何收集、使用您的个人信息</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal" style="text-indent: 21pt; mso-char-indent-count: 2">
        <span style="">
          <font face="等线"
            >我们会按照如下方式收集您在使用服务时主动提供或因为使用服务而产生的信息，用以向您提供服务以及保障您的账号安全。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal" style="text-indent: 21pt; mso-char-indent-count: 2">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">1、注册成为水母物联会员</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >1.1为注册成为会员并登录账号使用我们的服务，您需主动提供</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">手机号码、电子邮箱、用户密码</font>
          </span>
        </b>
        <span style="">
          <font face="等线"
            >。收集此类信息是为了满足相关法律法规的网络实名制要求。您可以根据自身需求选择提供</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >用户名（真实姓名或昵称）、头像、性别、生日、地区</font
            >
          </span>
        </b>
        <span style="">
          <font face="等线">这些非注册所必须的个人资料。</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >1.2如果您仅需要使用浏览、搜索产品/服务，您不需要注册成为我们的会员及提供上述信息。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >2、为便于我们为您提供快捷的登录服务，您可以选择绑定微信账号，此时我们会收集您的</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">昵称、头像</font>
          </span>
        </b>
        <span style="">
          <font face="等线"
            >。提示您注意，该功能以您自愿选择为准，若您不使用便捷登录功能，也不会影响您使用水母物联服务。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >3、当您使用水母物联服务时，为保障您正常使用我们的服务，维护我们服务运行安全及保障您的账号安全，我们会收集您的</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">移动终端设备信息</font>
            <font face="等线">
              {本协议凡提及移动终端设备，均指手机、平板电脑，也称“客户端”，设备型号、终端应用标识、终端标识（Android_ID（部分场景会在后台运行状态下收集）、ICCID、IDFA、OAID）、操作系统版本号、IP地址、应用安装列表/应用列表、水母物联软件版本号}、移动终端日志信息（服务故障信息、客户端故障信息）、智能物联网硬件设备信息（MAC地址、设备序列号、设备型号）、智能物联网硬件日志信息，
            </font>
          </span>
        </b>
        <span style="">
          <font face="等线">这类信息是为提供服务必须收集的基础信息。</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal" style="text-indent: 21pt; mso-char-indent-count: 2">
        <span style="">
          <font face="等线">提示您注意，</font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >移动终端设备信息、移动端终端日志信息、智能物联网硬件设备信息、智能物联网硬件日志信息</font
            >
          </span>
        </b>
        <span style="">
          <font face="等线">
            无法识别到特定自然人的身份信息，我们可能会间接收集这类信息用于改善水母物联服务。如果我们将这类非个人信息与其他信息结合可识别到特定自然人身份的，将会可能被视为个人信息，在此情况下，我们会取得您授权（法律另有规定外）并对上述信息做匿名化、去标识处理。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">4、向您提供设备添加服务</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >4.1
            为实现扫一扫设备添加功能，我们需要您通过主动提供移动终端设备的</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">相机</font>
            <font face="等线">/摄像头权限</font>
          </span>
        </b>
        <span style="">
          <font face="等线"
            >用于扫描设备二维码（本协议凡单独提及设备，均指摄像机、报警器、门锁）；为完成设备添加功能，我们还需要您主动提供</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">GPS（位置权限）、客户端位置信息</font>
          </span>
        </b>
        <span style="">
          <font face="等线">，会收集您的</font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">设备序列号、设备密码、客户端</font>
            <font face="等线"
              >WIFI信息（无线连接/SSID/BSSID/wifi参数/wifi信号强度/wifi列表/wifi状态）/蓝牙信息（蓝牙连接）</font
            >
          </span>
        </b>
        <span style="">
          <font face="等线"
            >，目的是搜索附近的设备、对设备进行配网和将设备添加在您的水母物联账号下，拒绝提供这些信息会使您无法正常使用设备添加服务。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >4.2
            为实现手动添加设备功能，若需要使用图库/照片的图片，我们还需要您主动提供</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">存储权限</font>
            <font face="等线">/照片权限</font>
          </span>
        </b>
        <span style="">
          <font face="等线"
            >，目的是将相册中的图片信息添加到流程中。为完成手动添加设备时设备自发现功能，我们还需要您主动提供</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">GPS（位置权限）、客户端位置信息</font>
          </span>
        </b>
        <span style="">
          <font face="等线">。为完成设备添加功能，我们还需要收集您的</font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">设备序列号、设备密码、客户端</font>
            <font face="等线"
              >WIFI信息（无线连接/SSID/BSSID/wifi参数/wifi信号强度/wifi列表/wifi状态）/蓝牙信息（蓝牙连接）</font
            >
          </span>
        </b>
        <span style="">
          <font face="等线"
            >，目的是搜索附近的设备、对设备进行配网和将设备添加在您的水母物联账号下，拒绝提供这些信息会使您无法正常使用设备添加服务。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">5、为实现设备管理服务，我们会收集您的</font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">设备序列号（</font>
          </span>
        </b>
        <span style="">
          <font face="等线">
            设备序列号是设备的唯一标识信息），目的是当您需对您选定的设备进行设备名称修改、设备配置管理操作，拒绝提供这些信息会使您无法正常使用设备管理服务。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">提示您注意，</font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">设备序列号、</font>
            <font face="等线">IP地址、设备MAC地址、操作日志、服务日志信息</font>
          </span>
        </b>
        <span style="">
          <font face="等线">
            无法识别到特定自然人的身份信息，我们可能会间接收集这类信息用于改善水母物联服务。如果我们将这类非个人信息与其他信息结合可识别到特定自然人身份的，将会可能被视为个人信息，在此情况下，我们会取得您授权（法律另有规定外）并对上述信息做匿名化、去标识处理。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">
            6、为实现视频播放自动切换横竖屏功能，我们会收集您的加速度传感器、陀螺仪传感器信息，拒绝提供这些信息会使您无法使用相关横竖屏自动切换服务，但不影响您正常使用其他功能。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">7、向您提供水母物联商城服务</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">7.1为实现下单交易功能，您需要提供您的</font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >订单信息、收货人姓名、收货地址、收货人手机号码</font
            >
          </span>
        </b>
        <span style="">
          <font face="等线">
            ，我们将使用这类信息来确定交易、支付结算、完成配送、为您查询订单以及提供客服咨询与售后服务，我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。若您不提供这类信息，您可能无法正常进行商品或服务的购买，但不影响您正常使用其他功能。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >7.2支付功能由第三方支付平台（微信、支付宝）向您提供服务。当您使用第三方支付平台支付时，我们需要将您的</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >订单号、交易金额、支付方式及其他反洗钱法律要求的必要信息</font
            >
          </span>
        </b>
        <span style="">
          <font face="等线">与第三方支付平台共享以实现支付功能。</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">7.3为向您开具电子发票，您需要提供</font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">邮箱地址或手机号</font>
          </span>
        </b>
        <span style="">
          <font face="等线"
            >，以接收电子发票。如您申请纸质发票，您需要提供</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">收货人姓名、收货地址、手机号码</font>
          </span>
        </b>
        <span style="">
          <font face="等线">，以便于我们向您寄送纸质发票。</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >7.4为实现查看附近水母物联体验店功能，我们需要调用您移动终端设备位置权限获取您的</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">位置信息</font>
          </span>
        </b>
        <span style="">
          <font face="等线"
            >，目的是使您查看您所在位置附近的水母物联体验店分布情况和地理位置。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >7.5我们可能不时举办抽奖活动。如您中奖，您需要提供</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">姓名、手机号码、收货地址</font>
          </span>
        </b>
        <span style="">
          <font face="等线"
            >，以便我们为您发放奖品。拒绝提供前述信息，可能无法领取奖品。此外，我们会对外公布中奖情况，若涉及您个人信息，将以去标识化方式展示。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">7.6为实现积分兑换功能，您需要提供您的</font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">收货人姓名、手机号码、收货人地址</font>
          </span>
        </b>
        <span style="">
          <font face="等线">
            ，我们将使用这类信息来完成配送、为您查询兑换订单以及提供客服咨询与售后服务。若您不提供这类信息，您可能无法正常进行商品或服务的兑换，但不影响您正常使用其他功能。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">8</font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">、为您提供客服服务、意见反馈和广告服务</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">8.1为实现在线客服功能，我们需要收集您的</font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">反馈结果、反馈的图片信息</font>
          </span>
        </b>
        <span style="">
          <font face="等线"
            >。拒绝提供这些信息仅会使您无法使用在线客服功能，但不影响您正常使用其他功能。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >8.2为了实现提供快速的售后400人工客服功能，我们需要您主动提供</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">电话访问权限</font>
          </span>
        </b>
        <span style="">
          <font face="等线"
            >，目的是为您提供更好的售后人工客服服务，拒绝提供这些信息仅会使您无法使用</font
          >
          <font face="等线">400人工客服功能，但不影响您正常使用其他功能。</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">8.3为实现产品建议功能，我们可能需要收集您的</font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">邮箱信息</font>
          </span>
        </b>
        <span style="">
          <font face="等线"
            >，目的是对您反馈的意见进行反馈答复。拒绝提供这些信息仅会使您无法接收建议及意见反馈答复，但不影响您正常使用其他功能。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >8.4为向您推送水母物联产品商业性信息广告（“水母物联产品广告”），我们可能需要收集您的</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">账号和设备信息</font>
          </span>
        </b>
        <span style="">
          <font face="等线">。</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >9、在同意隐私政策后，为便于用户复制张贴文本中的内容，我们将会读取剪切板信息；</font
            >
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <b>
          <span style="font-weight: bold">
            <font face="等线">
              10、为确保水母物联相关业务功能的正常实现，我们可能需要您开启移动终端设备系统访问权限以收集和使用您的个人信息；我们会在申请或使用操作系统的相关权限前以弹窗的形式向您询问并征得同意，
            </font>
          </span>
        </b>
        <span style="">
          <font face="等线"
            >如您不同意开启相应的权限或不提供您的个人信息，仅会使您无法使用对应的服务，但不影响您正常使用除该服务之外的其他服务或功能。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：</font
            >
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >1)与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公众知情等重大公共利益直接相关的；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >2)与犯罪侦查、起诉、审判和判决执行等直接相关的；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >3)出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">4)所收集的个人信息是您自行向社会公众公开的；</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >5)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">6)根据您要求签订和履行合同所必需的；</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >7)用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">8)为开展合法的新闻报道所必需的；</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >9)出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">10)法律法规规定的其他情形。</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            我们服务中的第三方服务由外部第三方主体提供，我们无法获得您在使用该类第三方服务时产生的信息。请您注意，目前我们不会主动从第三方获取您的个人信息。如未来为业务发展需要从第三方间接获取您个人信息，我们会在获取前向您明示您个人信息的来源、类型及使用范围，如我们开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权同意范围，我们将在处理您的个人信息前，征得您的明示同意；此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">
              如我们所收集您的信息经过加工处理后产生的新信息，且该信息能够单独或与其他信息结合识别您的身份或者反映您活动情况时，我们及时通过弹窗的方式告知您，并将重新取得您的同意。该类信息的共享、转让、公开披露、储存使用方式与本政策同。
            </font>
          </span>
        </b>
        <b>
          <span style="font-weight: bold">
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p class="MsoNormal">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >三、我们如何共享、转让、公开披露您的个人信息</font
            >
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">（一）共享</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >我们不会与任何公司、组织和个人分享您的个人信息，但以下情况除外：</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >1.在获得您的明确同意后，我们会与其他方共享您的个人信息。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >2.我们可能会根据法律法规规定，或按政府主管部门的强制性要求，共享您的个人信息。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">3.</font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">与我们的关联公司和关联产品共享</font>
          </span>
        </b>
        <span style="">
          <font face="等线">：为便于向您提供产品和</font>
          <font face="等线">
            /或服务，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本政策中所声明目的的约束。我们会通过关联公司间法律文件、内部系统及员工权限隔离等保护您个人信息的安全。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">4.</font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">与我们的合作伙伴共享</font>
          </span>
        </b>
        <span style="">
          <font face="等线">
            ：我们可能委托受信赖的合作伙伴来提供部分服务，因此我们可能会与合作伙伴共享您的某些个人信息。我们仅会出于为实现本隐私政策中声明的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。目前，
          </font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">
              我们的合作伙伴包括如下类型：供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供基础技术服务、提供咨询、分析等专业服务。被共享的合作伙伴可能有其独立的隐私政策或相关声明，我们建议您在做出相关授权前审慎查看，做出您认为适当的选择。
            </font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal" style="text-indent: 21pt; mso-char-indent-count: 2">
        <b>
          <span style="font-weight: bold">
            <font face="等线">
              您应知悉，如果为了向您提供服务而需要将您的信息共享至上述第三方，我们将审慎评估该第三方收集信息的目的、合法性、数据安全能力等各方面因素，并通过本政策或相关补充声明向您明示共享的日期、目的、信息规模，以及第三方的基本情况等相关信息及后果。
            </font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            若被共享的第三方违反法律法规要求或我们与第三方约定处理您的信息，我们将立即要求第三方停止相关行为，且自行采取或要求第三方采取有效补救措施控制或消除您的信息面临的安全风险；必要时我们也会解除与第三方合作，并要求第三方及时删除从我们处获得的您的个人信息。因共享您的个人信息发生安全事件对您的合法权益造成损害的，我们将按法律规定承担属于我们的责任。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <o:p>&nbsp;</o:p>
          </span>
        </b>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">（二）转让</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >1.在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">
            2.在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会告知您有关情况，并会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
          </font>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >若我们遭遇破产清算，无其他公司、组织投资进入且作为您的信息接收人，我们将收到破产裁定文书之日起删除您的个人信息。</font
            >
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">
              您应知悉，按上述的情况需要将您的信息转让至第三方，我们将审慎评估该第三方收集信息的目的、合法性、数据安全能力等各方面因素，并通过本政策或相关补充声明向您明示转让的日期、目的、信息规模，以及第三方的基本情况等相关信息及后果。
            </font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            若接收转让的第三方违反法律法规要求或我们与第三方约定处理您的信息，我们将立即要求第三方停止相关行为，且自行采取或要求第三方采取有效补救措施控制或消除您的信息面临的安全风险；必要时我们解除与第三方合作（合并、收购或破产清算除外），并要求第三方及时删除从我们处获得的您的个人信息。因转让您的个人信息发生安全事件对您的合法权益造成损害的，我们将按法律规定承担属于我们的责任。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">（三）公开披露</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >我们不会将您的个人信息公开披露，但以下情况除外：</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线">1.获得您明确同意后；</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p
        class="MsoNormal"
        style="text-indent: 10.5pt; mso-char-indent-count: 1"
      >
        <span style="">
          <font face="等线"
            >2.基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意：</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">1） 与国家安全、国防安全直接相关的；</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >2） 与公共安全、公共卫生、重大公共利益直接相关的；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >3） 与犯罪侦查、起诉、审判和判决执行等直接相关的；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >4）
            出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >5） 个人信息主体自行向社会公众公开的个人信息；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >6）
            从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >3.我们不会公开披露关于您的种族、民族、政治观点、宗教信仰等个人敏感信息的分析结果。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">
              基于上述情形需要披露您的个人信息，我们将通过弹窗、电子邮件方式告知您披露信息日期、规模、目的、范围、类型，并采取合理措施记录与保存披露的具体内容。其中，若涉及到您的个人敏感信息，我们还会告知您具体披露的信息内容。
            </font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">
              若我们违反上述规定，公开披露您的信息，一经发现，您有权按本政策提供的联系方式联系我们删除，我们经核实确认无误后立即停止公开披露，并发布通知要求相关接收方删除相应的信息。否则，给您的合作权益造成损害的，您有权按法律规定进行投诉或要求我们承担赔偿责任。
            </font>
          </span>
        </b>
        <b>
          <span style="font-weight: bold">
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <o:p>&nbsp;</o:p>
          </span>
        </b>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">四、我们如何保护和存储您的个人信息</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">（一）个人信息的保护技术与措施</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            1.我们非常重视您的信息安全。我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的个人信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            2.我们已经通过了以下关于信息安全和隐私保护的相关认证：信息安全等级保护三级认证、ISO
            27001信息安全管理体系认证、ISO 27017 云服务信息安全管理体系认证、ISO
            27018 云中个数据（PII）隐私保护认证、ISO 27701
            隐私信息管理体系认证、CSA
            STAR云安全认证、ITSS云服务SaaS服务三级认证及对标GDPR的IoT服务隐私保护认证。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >3.我们强烈建议您使用复杂密码，协助我们保证您的账号安全，我们将尽力保障您发送给我们的任何信息的安全性。</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">
              请您理解并知悉，互联网并非绝对安全的环境。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供或共享。如您发现自己的个人信息泄密，尤其是您的账号及密码发生泄露，请您立即联络我们的客服，以便我们协助您采取相应措施。
            </font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            4.若发生个人信息泄露等安全事件，我们将按照法律法规的要求，及时向您告知:安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们会及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">（二）个人信息的存储</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">1.信息存储的地点</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >我们会按照法律法规规定，在中华人民共和国境内运营中收集和产生的个人信息，将存储在中华人民共和国境内。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">2.信息存储的期限</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            一般而言，我们只会在达成本隐私政策所述目的所需的最短期限内保留您的个人信息，除非法律有强制的存留要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。而我们判断前述期限的标准包括：
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >1）完成与您相关的交易目的、维护相应交易及业务记录、应对您可能的查询或投诉；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">2）保证我们为您提供服务的安全和质量；</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">3）您是否同意更长的留存期间；</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">4）是否存在保留期限的其他特别约定。</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >请您注意，当您成功申请注销会员账号后，我们将在您提出申请的</font
          >
          <font face="等线"
            >48小时内完成对您的账号注销审核，审核通过后，我们将对您的个人信息进行删除或匿名化处理。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            如果我们终止服务或运营，我们会至少提前三十日通过系统通知、发布公告或弹窗方式向您告知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理，并在终止服务或运营后立即停止收集您的个人信息。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">五、您的权利</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >按照中国相关的法律、法规、标准，在您使用我们的产品和</font
          >
          <font face="等线"
            >/服务期间，您拥有访问、更正、删除您的个人信息，撤回对个人信息使用的同意及注销账号的权利，您可以参考下面的指引进行操作。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">（一）访问、更正您的个人信息</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >若您要访问、修改以下信息，您可在进入水母物联应用后点击相关功能按钮实现：</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >1.若要访问、修改您的头像、用户名、手机号基本信息：</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">点击</font>
          <font face="等线"
            >“我的”，点击页面上方头像栏，进行数据的查看修改维护。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">2.若要访问您的视频、图片服务信息：</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">点击导航栏中的</font>
          <font face="等线"
            >“消息”功能按钮，进入消息模块，进行相关信息的访问。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">3.若要访问您的设备信息：</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">点击</font>
          <font face="等线"
            >“我的”→“我的设备”功能按钮，进行设备数据信息查看。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">4.若要访问您的订单信息：</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">点击</font>
          <font face="等线"
            >“我的”→“我的订单”功能按钮，进行订单数据信息查看。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">5.若您要更正、补充您的其他信息：</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >您发现您提交的其他信息不准确或不完整的，您可以按本政策提供的联系方式联系我们予以更正、补充。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">（二）删除您的个人信息</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >在以下情形中，您可以向我们提出删除个人信息的请求：</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">1.如果我们处理个人信息的行为违反法律法规；</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >2.如果我们收集、使用您的个人信息，却未征得您的同意；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >3.如果我们处理个人信息的行为违反了与您的约定；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >4.如果您不再使用我们的产品或服务，或您注销了账号；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">5.如果我们不再为您提供产品或服务。</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            您可以通过发送邮件提出你的删除请求，若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">
              当您的个人信息从我们的服务系统中删除或匿名化处理后，我们可能不会立即在备份系统中进行删除或匿名化处理，但会在备份更新时进行删除或匿名化处理。
            </font>
          </span>
        </b>
        <b>
          <span style="font-weight: bold">
            <o:p></o:p>
          </span>
        </b>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <o:p>&nbsp;</o:p>
          </span>
        </b>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">（三）转移个人信息</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            若您需要将我们收集到的信息转移至第三方，您可以通过本政策提供的联系方式与我们联系，经过我们核查，满足国家规定的条件后，我们将于处理您的请求。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >请您注意，您的信息转移至第三方，您的个人信息将从我们的服务系统中删除或匿名化处理。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <o:p>&nbsp;</o:p>
          </span>
        </b>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">六、我们如何处理未成年人的个人信息</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >我们非常重视对未成年人个人信息的保护。我们在向用户提供我们的产品或服务时不以年龄识别为前提，但我们的产品与</font
          >
          <font face="等线"
            >/或服务性质要求您应当为具备完全民事行为能力的成年人。</font
          >
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线">若您是</font>
            <font face="等线">
              18周岁以下的未成年人，请务必在使用本服务前，在父母或其他监护人监护、指导下共同仔细阅读本隐私政策，并在征得监护人同意的前提下使用本服务或提供个人信息。若您为实现与儿童互动，通过我们的产品与/或服务收集或向我们提交未成年人的个人信息的，请您务必确保已事先获得其法定监护人的授权同意。
            </font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >如果父母或其他监护人有理由相信未成年人未经其事先同意而向我们提交了个人信息，请通过本政策</font
            >
          </span>
        </b>
        <span>
          <a href="#_Toc50281380">
            <b>
              <u>
                <span
                  class="16"
                  style="
                    color: rgb(70, 120, 134);
                    font-weight: bold;
                    text-decoration: underline;
                    text-underline: single;
                  "
                >
                  <font face="等线">第八节</font>
                </span>
              </u>
            </b>
          </a>
        </span>
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >中的联系方式与我们联系，要求更正或删除涉及未成年人个人信息的内容。</font
            >
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，我们会尽快删除相关数据。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">七、我们如何使用</font>
            <font face="等线">Cookie和同类技术</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">（一）</font>
          <font face="等线">Cookie的使用</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >为确保网站正常运转、为您获得更轻松的访问体验，我们会在您的计算机或移动终端设备上存储</font
          >
          <font face="等线">
            Cookie、Flash
            Cookie，或浏览器（或关联应用程序）提供的其他通常包含标识符、站点名称以及一些号码和字符的本地存储（统称“Cookie”）。借助于Cookie，网站能够存储您的偏好或购物车内的商品数据。如果您的浏览器或浏览器附加服务允许，您可修改对Cookie的接受程度或拒绝我们的Cookie。有关详情，请参见AboutCookies.org。但如果您这么做，在某些情况下可能会影响您安全访问我们的网站，且可能需要在每一次访问我们的网站时更改用户设置。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">在您未拒绝接受</font>
          <font face="等线"
            >cookies的情况下，我们会在您的计算机上设定或取用cookies，以便您能登录或使用依赖于cookies的我们的平台服务或功能。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">您有权选择接受或拒绝接受</font>
          <font face="等线">
            cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的我们的平台服务或功能。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">通过我们所设</font>
          <font face="等线">cookies所取得的有关信息，将适用本政策。</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">(二）Cookie同类技术</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">除</font>
          <font face="等线">
            Cookie外，我们还会在网站上使用网站信标、像素标签或其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好，以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">八、联系我们</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            我们设立了专门的个人信息保护团队和个人信息保护负责人，如果您对本政策有任何疑问，需要我们释明，或您对本政策有任何的意见或建议、投诉，可通过以下方式与我们联系：
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">1.联系电话：010-56100119；</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">2.邮件寄到如下地址：</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >深圳市龙岗区宝龙街道宝龙社区南同大道28号贝斯达医疗器械大厦1栋B号厂房1B301，</font
          >
          <font face="等线">个人信息保护工作组（收），邮编：</font>
        </span>
        <span style="">518100</span>
        <span style="">
          <font face="等线"
            >一般情况下，我们将尽快审核所涉问题，并在验证您的用户身份后十五日内予以回复。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            如果您对收到的答复不满意，您可以投诉至网信、公安及工商等相关监管部门或诉至司法机关。如果您需要我们协助提供相关投诉渠道的信息，我们将尽力为您提供。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线">九、本政策如何更新</font>
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">我们可能会适时地对本政策进行修订或变更。</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会在本页面上发布对本政策所作的任何变更，您可以在水母物联官网网站首页查看本政策，也可在水母物联
          </font>
          <font face="等线"
            >App通过“我的”→“关于”→“水母物联隐私政策相关”中查看本政策。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b>
          <span style="font-weight: bold">
            <font face="等线"
              >您应当知悉，对于本政策重大变更，我们会以推送通知、弹窗、发送电子邮件等的形式通知您并重新取得您的同意。</font
            >
          </span>
        </b>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">本政策所指的重大变更包括但不限于：</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息种类、个人信息的处理方式等；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            2.我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；且变更后的所有者处理信息的目的、处理信息方式和处理的个人信息种类变更的；
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >3.个人信息共享、转让或公开披露的主要对象发生变化。如接收方变更处理目的、处理方式的。</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >4.您参与个人信息处理方面的权利及其形式方式发生变化；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线"
            >5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</font
          >
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">6.个人信息安全影响评估报告表明存在高风险时。</font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <font face="等线">
            我们鼓励您在每次使用水母物联时都查阅我们的隐私政策。若您在本政策更新生效后继续使用本服务，即表示您已充分阅读、理解并接受更新后的政策并愿意接受更新后的政策约束。
          </font>
        </span>
        <span style="">
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span style="">
          <o:p>&nbsp;</o:p>
        </span>
      </p>
    </div>
    <article v-else-if="documentData" class="Section0 legal-document" :lang="lang">
      <h1>{{ documentData.title }}</h1>
      <p class="document-meta"><strong>{{ documentData.updated }}</strong></p>
      <p class="document-meta"><strong>{{ documentData.effective }}</strong></p>
      <section class="introduction">
        <p v-for="(paragraph, index) in documentData.introduction" :key="`intro-${index}`">{{ paragraph }}</p>
      </section>
      <section v-for="(section, sectionIndex) in documentData.sections" :key="`section-${sectionIndex}`">
        <h2>{{ section.title }}</h2>
        <p v-for="(paragraph, paragraphIndex) in section.paragraphs" :key="`paragraph-${sectionIndex}-${paragraphIndex}`">{{ paragraph }}</p>
      </section>
    </article>
  </div>
</template>

<script setup>
import { computed, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import { privacyPolicyDocuments } from './legalDocuments.js';

const route = useRoute();
const normalizeLang = (value) => (['zh-CN', 'en', 'zh-TW'].includes(value) ? value : 'zh-CN');
const lang = computed(() => normalizeLang(Array.isArray(route.query.lang) ? route.query.lang[0] : route.query.lang));
const documentData = computed(() => privacyPolicyDocuments[lang.value]);

watchEffect(() => {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = lang.value;
  document.title = documentData.value?.title || '水母物联隐私政策';
});
</script>

<style scoped>
body {
  font-family: Arial, sans-serif;
  margin: 0;
  /* padding: 20px; */
}

h1,
h2,
h3 {
  color: #333;
}

p {
  margin-bottom: 15px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
}

.Section0 {
  padding: 40px 15px 50px;
}

.legal-document { max-width: 920px; margin: 0 auto; color: #222; font-family: Arial, "PingFang TC", "Microsoft JhengHei", sans-serif; font-size: 16px; line-height: 1.75; }
.legal-document h1 { margin: 0 0 28px; text-align: center; font-size: 28px; }
.legal-document h2 { margin: 32px 0 12px; font-size: 20px; }
.legal-document p { margin: 0 0 15px; }
.document-meta { margin-bottom: 6px !important; }
.introduction { margin-top: 28px; }
</style>
